'use strict';
HeaderController.$inject = ['$scope', '$mdDialog', '$timeout'];
angularApp.dcyApplication.register.controller('headerCtrl', ($scope, $mdDialog, $timeout) => new HeaderController($scope, $mdDialog, $timeout));
